export default ["/", "/privacy-politics"]